<template>
    <div>
        <h2>{{ $t("wp.authenticating") }}</h2>
        <div class="d-flex justify-content-center align-items-center" style="font-size: 22px">
            <div>
                <div>{{ $t("wp.activationTitle") }}</div>
                <ol>
                    <li>{{ $t("wp.wpIntegrationInstruction1") }}</li>
                    <li>{{ $t("wp.wpIntegrationInstruction2") }}</li>
                    <li>{{ $t("wp.wpIntegrationInstruction3") }}</li>
                </ol>
            </div>
            <div v-if="channelId">
                <div
                    v-if="isChannelQRCodeGenerating()"
                    class="p-3 d-flex flex-column justify-content-center align-items-center"
                >
                    <span class="text-info">{{ $t("wp.qrGeneratingWait") }}</span>
                    <md-progress-spinner
                        class="md-accent text-danger"
                        :md-diameter="20"
                        md-mode="indeterminate"
                    ></md-progress-spinner>
                </div>
                <div
                    v-if="isChannelAuthenticating()"
                    class="p-3 d-flex flex-column justify-content-center align-items-center"
                >
                    <span class="text-info">{{ $t("wp.authenticatingWait") }}</span>
                    <md-progress-spinner
                        class="md-accent text-danger"
                        :md-diameter="20"
                        md-mode="indeterminate"
                    ></md-progress-spinner>
                </div>

                <div v-if="isChannelQRCodeGenerated()">
                    <img
                        :src="getQRAddress()"
                        :alt="$t('wp.qrCodeImageAlt')"
                        class="qr-code"
                        :key="imageRefreshKey"
                    />
                </div>
            </div>
            <div v-else>
                <div v-if="isQRCodeGenerating" class="p-3 d-flex flex-column justify-content-center align-items-center">
                    <span class="text-info">{{ $t("wp.qrGeneratingWait") }}</span>
                    <md-progress-spinner
                        class="md-accent text-danger"
                        :md-diameter="20"
                        md-mode="indeterminate"
                    ></md-progress-spinner>
                </div>
                <div v-if="isAuthenticating" class="p-3 d-flex flex-column justify-content-center align-items-center">
                    <span class="text-info">{{ $t("wp.authenticatingWait") }}</span>
                    <md-progress-spinner
                        class="md-accent text-danger"
                        :md-diameter="20"
                        md-mode="indeterminate"
                    ></md-progress-spinner>
                </div>

                <div v-if="isQRCodeGenerated">
                    <img
                        :src="getQRAddress()"
                        :alt="$t('wp.qrCodeImageAlt')"
                        class="qr-code"
                        :key="imageRefreshKey"
                    />
                </div>
            </div>
        </div>
        <div v-if="continueToWait" class="p-3 d-flex flex-column justify-content-center align-items-center">
            <span class="text-info">{{ $t("wp.pleaseContinueToWaitUntilCompleted") }}</span>
            <md-progress-spinner :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
        </div>
    </div>
</template>

<script>
import { getPersistenceData } from "../../utils/persistenceStorage";
import CONFIG from "../../config/config";
import { mapActions, mapGetters, mapState } from "vuex";
import log2 from "../../utils/log2";
import _ from "lodash";

const LSTATES = CONFIG.WHATSAPP.LAUNCH_STATES;
const log = log2("QRCodeAuthentication");
export default {
    name: "QRCodeAuthentication",
    props: {
        channelId: {
            type: String,
            required: false,
        },
        channel: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            imageRefreshKey: 0,
            continueToWait: false,
            isV2Channel: this.channel?.type === "whatsapp-v2",
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            channelInfo: (state) => state.whatsapp.channelInfo,

            isQRCodeGenerated: (state) =>
                _.get(state.whatsapp, "info.status.status.LAUNCH_STATE") === LSTATES.QR_CODE_GENERATED,
            isAuthenticating: (state) =>
                _.get(state.whatsapp, "info.status.status.LAUNCH_STATE") === LSTATES.AUTHENTICATING,
        }),
    },

    methods: {
        isChannelQRCodeGenerating() {
            const info = this.channelInfo[this.channelId];
            log("isChannelQRCodeGenerating", info);
            if (info) {
                if (this.isV2Channel) {
                    return info.status.state === LSTATES.QR_CODE_GENERATING;
                } else {
                    return info.status.status.LAUNCH_STATE === LSTATES.QR_CODE_GENERATING;
                }
            }
            return false;
        },
        isChannelAuthenticating() {
            const info = this.channelInfo[this.channelId];
            log("isChannelAuthenticating", info);
            if (info) {
                if (this.isV2Channel) {
                    return false;
                } else {
                    return info.status.status.LAUNCH_STATE === LSTATES.AUTHENTICATING;
                }
            }
            return false;
        },
        isChannelQRCodeGenerated() {
            console.log("isChannelQRCodeGenerated in", this.isQRCodeGenerated);
            const info = this.channelInfo[this.channelId];
            log("isChannelQRCodeGenerated", info);
            if (info) {
                if (this.isV2Channel) {
                    return info.status.state === LSTATES.QR_CODE_GENERATED;
                } else {
                    return info.status.status.LAUNCH_STATE === LSTATES.QR_CODE_GENERATED;
                }
            }
            return false;
        },
        getQRAddress() {
            console.log("getQRAddress in");
            if (this.channelId) {
                if (this.isV2Channel) {
                    return `${CONFIG.WHATSAPP.qrAddressV2}?siteId=${this.site._id}&channelId=${
                        this.channelId
                    }&token=${getPersistenceData("Admin-Token")}&r=${Math.random() * 1000}`;
                } else {
                    return `${CONFIG.WHATSAPP.qrAddress}?siteId=${this.site._id}&channelId=${
                        this.channelId
                    }&token=${getPersistenceData("Admin-Token")}&r=${Math.random() * 1000}`;
                }
            } else {
                return `${CONFIG.WHATSAPP.qrAddress}?siteId=${this.site._id}&token=${getPersistenceData(
                    "Admin-Token"
                )}&r=${Math.random() * 1000}`;
            }
        },
    },
    mounted() {
        this.continueToWait = true;
        setTimeout(() => {
            this.continueToWait = false;
        }, 4000);
        this.timerId = setInterval(() => {
            this.imageRefreshKey++;
        }, 5000);
        log("QRCodeAuthentication timer started", this.timerId);
    },
    beforeDestroy() {
        clearInterval(this.timerId);
        log("QRCodeAuthentication timer stopped", this.timerId);
    },
};
</script>

<style scoped>
.qr-code {
    width: 150px;
    height: 150px;
    filter: grayscale(1);
}

@keyframes colorAnim {
    from {
        filter: hue-rotate(0deg);
    }
    to {
        filter: hue-rotate(360deg);
    }
}
</style>
